export default __webpack_public_path__ + "static/media/img_step_lucia03-12.6c0d2c5d.jpg";